import actions from './actions'
import mutations from './mutations'
import state from './state'
import getters from './getters'

const site = {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}

export default site
